<template>
	<div v-show="parent4Show">
        <Row>
            <Col :span="20">
                <div style="text-align:center">
                    <Button @click="leftFn"><Icon type="chevron-left"></Icon></Button>
                    <Button @click="rightFn"><Icon type="chevron-right"></Icon></Button>
                </div>    
            </Col>
            <Col :span="10" class="content">
                <h2>模板信息</h2>
                <div class="content_z" :style="{height:'650px','overflow-y':'scroll'}" >
                    <div v-for="(item,index) in getData" :key="index">
                        <component :is="item.model" :msg="item"></component>
                    </div>
                </div>
            </Col>
            <Col :span="10" class="answer">
                <h2>拆分信息</h2>
                <div class="content_z" :style="{height:'650px','overflow-y':'scroll'}">
                    <div v-for="(item,index) in getData2" :key="index">
                        <component :is="item.model" :msg="item"></component>
                    </div>
                </div>
            </Col>
            <Col span="4">
                <h2>基础信息</h2>
                <Form ref="formItem" :rules="formValidate" :model="addData">
                    <Form-item label="模板名称" prop="name">
                        <Input type="text" v-model="addData.name" placeholder="请输入..."></Input>
                    </Form-item>
                    <Form-item label="说明" prop="prompt">
                        <Input type="textarea" v-model="addData.prompt" placeholder="请输入..."></Input>
                    </Form-item>
                </Form>
                <Button type="primary" @click="submitFn('formItem')">保存拆分</Button>
            </Col>
        </Row>
        <el-dialog title="提交" :visible.sync="addShow">
            <p>确认要拆分解析吗？</p>
            <div slot="footer" class="dialog-footer">
                <Button @click="addShow=false">取 消</Button>
                <Button type="primary" @click="axiosFn">确 定</Button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import mod from './split'
	export default{
		data(){
			return {
                addData:{
                    pid:'',
                    name:'',
                    prompt:'',
                    textval:'',
                    surplus:'',
                },
                getData:[],
                getData2:[],
                init:{},
                formValidate:{
                    name: [
                        { required: true, message: '模板名称不能为空', trigger: 'change' }
                    ],
                    prompt: [
                        { required: true, message: '模板名称不能为空', trigger: 'change' }
                    ],
                    td: [
                        { required: true, message: '表头名称不能为空', trigger: 'change' }
                    ],
                },
                addShow:false,
			}
		},
        computed: {
            parent4Show () {
                return this.$store.state.parent4Show;
            }
        },
		created(){
			this.$store.dispatch('parent4ShowFn');
            this.getDataFn();
		},
		methods:{
            leftFn(){
                switch(this.type){
                    case 1:
                        for(let i=0; i<this.getData2[0].init.length; i++){
                            this.getData[0].data.push(this.getData2[0].init[i]);
                        }
                        for(let i=0; i<this.getData2[0].data.length; i++){
                            for(let n=0; n<this.getData2[0].init.length; n++){
                                if(this.getData2[0].data[i].btnIndex == this.getData2[0].init[n].btnIndex){
                                    this.getData2[0].data.splice(i,1);
                                }
                            }
                        }
                        break;
                    case 2:
                        for(let name in this.getData2[0].init){
                            for(let i=0; i<this.getData2[0].init[name].length; i++){
                                this.getData[0].data[name].push(this.getData2[0].init[name][i]);
                            }
                            for(let i=0; i<this.getData2[0].data[name].length; i++){
                                for(let n=0; n<this.getData2[0].init[name].length; n++){
                                    if(this.getData2[0].data[name][i].btnIndex == this.getData2[0].init[name][n].btnIndex){
                                        this.getData2[0].data[name].splice(i,1);
                                    }
                                }
                            }
                        }
                        break;
                    case 3:
                        for(let name in this.getData2[0].init){
                            for(let i=0; i<this.getData2[0].init[name].length; i++){
                                for(let item in this.getData2[0].init[name][i]){
                                    for(let j=0; j<this.getData2[0].init[name][i][item].length; j++){
                                        this.getData[0].data[name][i][item].push(this.getData2[0].init[name][i][item][j]);
                                    }
                                }
                            }
                            for(let i=0; i<this.getData2[0].data[name].length; i++){
                                for(let item in this.getData2[0].data[name][i]){
                                    for(let j=0; j<this.getData2[0].data[name][i][item].length; j++){
                                        for(let n=0; n<this.getData2[0].init[name][i][item].length; n++){
                                            if(this.getData2[0].data[name][i][item][j].btnIndex == this.getData2[0].init[name][i][item][n].btnIndex){
                                                this.getData2[0].data[name][i][item].splice(j,1);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        break;
                }
                this.$set(this.getData[0],'init',JSON.parse(JSON.stringify(this.init)));
                this.$set(this.getData2[0],'init',JSON.parse(JSON.stringify(this.init)));
            },
            rightFn(){
                switch(this.type){
                    case 1:
                        for(let i=0; i<this.getData[0].init.length; i++){
                            this.getData2[0].data.push(this.getData[0].init[i]);
                        }
                        for(let i=0; i<this.getData[0].data.length; i++){
                            for(let n=0; n<this.getData[0].init.length; n++){
                                if(this.getData[0].data[i].btnIndex == this.getData[0].init[n].btnIndex){
                                    this.getData[0].data.splice(i,1);
                                }
                            }
                        }
                        break;
                    case 2:
                        for(let name in this.getData[0].init){
                            for(let i=0; i<this.getData[0].init[name].length; i++){
                                this.getData2[0].data[name].push(this.getData[0].init[name][i]);
                            }
                            for(let i=0; i<this.getData[0].data[name].length; i++){
                                for(let n=0; n<this.getData[0].init[name].length; n++){
                                    if(this.getData[0].data[name][i].btnIndex == this.getData[0].init[name][n].btnIndex){
                                        this.getData[0].data[name].splice(i,1);
                                    }
                                }
                            }
                        }
                        break;
                    case 3:
                        for(let name in this.getData[0].init){
                            for(let i=0; i<this.getData[0].init[name].length; i++){
                                for(let item in this.getData[0].init[name][i]){
                                    for(let j=0; j<this.getData[0].init[name][i][item].length; j++){
                                        this.getData2[0].data[name][i][item].push(this.getData[0].init[name][i][item][j]);
                                    }
                                }
                            }
                            for(let i=0; i<this.getData[0].data[name].length; i++){
                                for(let item in this.getData[0].data[name][i]){
                                    for(let j=0; j<this.getData[0].data[name][i][item].length; j++){
                                        for(let n=0; n<this.getData[0].init[name][i][item].length; n++){
                                            if(this.getData[0].data[name][i][item][j].btnIndex == this.getData[0].init[name][i][item][n].btnIndex){
                                                this.getData[0].data[name][i][item].splice(j,1);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        break;
                }
                this.$set(this.getData[0],'init',JSON.parse(JSON.stringify(this.init)));
                this.$set(this.getData2[0],'init',JSON.parse(JSON.stringify(this.init)));
            },
            submitFn(name){
                let _this=this;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.addShow=true;
                    } else {
                        _this.$Message.error('表单验证失败!');
                    }
                })
            },
            axiosFn(){
                let _this=this;
                this.addShow=false;
                this.addData.textval=JSON.stringify(this.getData2[0].data);
                this.addData.surplus=JSON.stringify(this.getData[0].data);
                this.$http.post('/web/template/addSonTemplate',_this.addData).then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title: '保存拆分',
                            desc: res.message,
                        });
                        _this.$router.push({path:'/templateList/splitList',query:{temid:_this.$route.query.temid}});
                    }else{
                        _this.$Notice.error({
                            title: '保存拆分',
                            desc: res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Message.error(res.message);
                })
            },
            getDataFn(){
                let _this=this;
                this.$http.get('/web/template/getTemplateByTemid',{
                    params:{
                        temid:_this.$route.query.temid,
                    }
                }).then(function(res){
                    if(res.success){
                        _this.getData=[];
                        _this.addData.pid=res.data.temid;

                        let arr=JSON.parse(res.data.textval);
                        let model='';
                        let batch={};
                        let init={};
                        switch(res.data.type){
                            case 1:
                                model = 'one';
                                batch=[];
                                init=[];
                                break;
                            case 2:
                                model = 'two';
                                for(let name in arr){
                                    batch[name]=[];
                                    init[name]=[];
                                }
                                break;
                            case 3:
                                model = 'three';
                                for(let name in arr){
                                    batch[name]=[];
                                    init[name]=[];
                                    for(let i=0; i<arr[name].length; i++){
                                        batch[name].push({});
                                        init[name].push({});
                                        for(let item in arr[name][i]){
                                            batch[name][i][item]=[];
                                            init[name][i][item]=[];
                                        }
                                    }
                                }
                                break;
                        };
                        _this.getData.push({
                            data:arr,
                            init:init,
                            model:model,
                        });
                        _this.getData2.push({
                            data:batch,
                            init:init,
                            model:model,
                        });
                        _this.init=JSON.parse(JSON.stringify(init));
                        _this.type=res.data.type;
                    }else{
                        _this.$Message.error('加载失败!');
                    }
                }).catch(function(res){
                    _this.$Message.error('加载失败');
                })
            },
		},
        components:mod
	}
</script>
<style scoped>
    h2{ background:#464c5b; color:#fff; height:32px; line-height:32px; padding-left:10px;}
    h3{ background:#f8f8f9; height:32px; line-height:32px; padding-left:10px;}
    .xlsxLi{ line-height:30px; border-bottom:1px dashed #464c5b; padding:5px; }
    .drag{ padding:20px 0; }
    .content_z{
        overflow:hidden;
        position:relative;
    }
</style>


// WEBPACK FOOTER //
// src/components/template/splitTemplate.vue